export default {
  cancelled: 'Reset Cancelled',
  pending: 'Reset in Progress',
  sent: 'Reset in Progress',
  complete: 'Reset Complete'
};